import Vue from 'vue'

export default {
	namespaced: true,
	state: {
		list: []
	},
	actions: {
		async fetch({ commit }, {start, end}) {
			let response = await Vue.http.get(`history?date_start=${start}&date_end=${end}`, )
			commit('setList', response.data)
		}
	},
	mutations: {
		setList(state, history) {
			state.list = [...history]
		}
	}
}
